// Shown on first launch/login while the initial sync is still pulling data down,
// so the "Your kitchen is quiet" empty state doesn't flash before the recipes
// arrive. See Home for when this vs. EmptyHome is chosen.
import { useT } from "@reciperoll/core";

export default function LoadingHome() {
  const t = useT();
  return (
    <div className="max-w-5xl mx-auto flex flex-col items-center justify-center py-24 text-center">
      <div
        className="w-10 h-10 rounded-full border-2 border-line border-t-terracotta animate-spin"
        role="status"
        aria-label={t("home.loadingAria")}
      />
      <p className="mt-4 text-ink-soft">{t("home.loading")}</p>
    </div>
  );
}
